import { useState } from 'react';
import { getSelectedAccountInfo } from '@ibk/shared-auth';
import { usePostValidateDuplicateMutation } from '../../services/pixApi';
export function usePostValidateDuplicate() {
    const [trigger] = usePostValidateDuplicateMutation();
    const [loading, setLoading] = useState(false);
    const [isDuplicate, setIsDuplicate] = useState();
    async function postValidateDuplicate(body) {
        setLoading(true);
        setIsDuplicate(undefined);
        try {
            const { data } = await trigger({ body: { ...body, accountId: getSelectedAccountInfo()?.accountId } });
            if (data?.result) {
                setIsDuplicate(true);
            }
            else {
                setIsDuplicate(false);
            }
        }
        catch {
            setIsDuplicate(false);
        }
        finally {
            setLoading(false);
        }
    }
    return {
        loading,
        setLoading,
        isDuplicate,
        setIsDuplicate,
        postValidateDuplicate,
    };
}
